(function () {
  "use strict";

  var initializedSections = new WeakSet();

  function initSection(section) {
    if (!section || initializedSections.has(section)) return;
    initializedSections.add(section);

    var cards = Array.prototype.slice.call(section.querySelectorAll("[data-kll-secondary-card]"));
    var reduceMotion = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var activeIndex = 0;
    var timer = null;

    section.classList.add("has-js");

    function setActive(index) {
      if (!cards.length) return;

      activeIndex = (index + cards.length) % cards.length;
      cards.forEach(function (card, cardIndex) {
        card.classList.toggle("is-active", cardIndex === activeIndex);
      });
    }

    function stopCycle() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function startCycle() {
      stopCycle();
      if (reduceMotion || cards.length < 2 || document.hidden) return;

      timer = window.setInterval(function () {
        setActive(activeIndex + 1);
      }, 3200);
    }

    cards.forEach(function (card, index) {
      card.addEventListener("pointerenter", function () {
        stopCycle();
        setActive(index);
      });

      card.addEventListener("focus", function () {
        stopCycle();
        setActive(index);
      });

      if (!reduceMotion) {
        card.addEventListener("pointermove", function (event) {
          var bounds = card.getBoundingClientRect();
          var x = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
          var y = Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height));

          card.style.setProperty("--kll-mid-card-x", (x * 100).toFixed(2) + "%");
          card.style.setProperty("--kll-mid-card-y", (y * 100).toFixed(2) + "%");
        });
      }
    });

    section.addEventListener("pointerleave", startCycle);
    section.addEventListener("focusout", function (event) {
      if (!section.contains(event.relatedTarget)) startCycle();
    });

    function reveal() {
      section.classList.add("is-visible");
      setActive(0);
      startCycle();
    }

    if (reduceMotion || !("IntersectionObserver" in window)) {
      reveal();
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(section);
          reveal();
        });
      }, {
        threshold: 0.16,
        rootMargin: "0px 0px -8% 0px"
      });

      observer.observe(section);
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stopCycle();
      else if (section.classList.contains("is-visible")) startCycle();
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches("[data-kll-august-secondary]")) {
      initSection(scope);
    }

    Array.prototype.forEach.call(
      scope.querySelectorAll("[data-kll-august-secondary]"),
      initSection
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
